import * as React from "react";
import { Bling as GPT } from "react-gpt";
import { adBannerLarge, adBannerSmall, adMobileRectangle, adMobileSquare, adPositions, adSuperzone, adUnits, adViewports, generateAdTargeting, } from "../../utils/ads";
export var AdUnitSuperzone = function (_a) {
    var adUnit = _a.adUnit, targeting = _a.targeting;
    return (React.createElement(GPT, { adUnitPath: adUnits[adUnit], sizeMapping: [
            { viewport: adViewports.mobile, slot: [adMobileRectangle, adMobileSquare, adSuperzone] },
            { viewport: adViewports.tablet, slot: [adMobileRectangle, adMobileSquare, adSuperzone] },
            { viewport: adViewports.laptop, slot: [adBannerLarge, adBannerSmall, adSuperzone] },
        ], targeting: generateAdTargeting(Object.assign({}, targeting, {
            position: adPositions.hero,
        })) }));
};



//////////////////
// WEBPACK FOOTER
// ./app/shared/components/ad/adUnitSuperzone.tsx
// module id = gBmD
// module chunks = 2